import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';


i18n

  // detect user language

  // learn more: https://github.com/i18next/i18next-browser-languageDetector

  .use(LanguageDetector)

  // pass the i18n instance to react-i18next.

  .use(initReactI18next)

  // init i18next

  // for all options read: https://www.i18next.com/overview/configuration-options

  .init({

    debug: true,
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    resources: {
      en: {
        translation: {
          description: {
            part1: 'Edit <1>src/App.js</1> and save to reload.',
            part2: 'Learn React',
            about: 'ABOUT',
            technologies: 'TECHNOLOGIES',
            techskills: 'TECHNICAL SKILLS',
            techskill1: 'Full-Stack Java development',
            techskill2: 'Cloud Computing',
            techskill3: 'DevOps',
            techskill4: 'Cybersecurity',
            techskill5: 'OAuth2',
            techskill6: 'Microservices',
            techskill7: 'REST APIs',
            techskill8: 'PL/SQL',
            techskill9: 'Kafka',
            techskill10: 'SonarQube',
            techskill11: 'Nodejs',
            techskill12: 'Shell Scripting',
            experience: 'EXPERIENCE',
            domains: 'DOMAINS',
            education: 'EDUCATION',
            languages: 'LANGUAGES',
            phone: 'Phone: 514-742-6851',
            email: 'Email: tamara9@rogers.com',
            linkedin: 'LinkedIn profile: linkedin.com/in/tamaram',
            technologies1: 'TECHNOLOGY STACK',
            experiences1: 'PROFESSIONAL EXPERIENCES',
            domains1: 'DOMAINS OF EXPERIENCES',
            languages1: 'LANGUAGES',
            languages2: '(Spoken, written, read)',
            education1: 'PROFESSIONAL EDUCATION',
            profile: 'PROFILE',
            skills: 'SKILLS',
            profile1: '•	Accomplished professional with more than 15 years of professional experience in Java technologies',
            profile2: '•	Experience of work in all the SDLC phases',
            profile3: '•	Development, integration and maintenance of Web applications in different industries',
            profile4: '•	Collaboration with international teams in USA, United Kindom, India, Australia, etc.',
            profile5: '•	Languages: French, English, Ukrainian, Russian',
            skill1: '•	Develop, maintain, deploy and support Web applications',
            skill2: '•	Solve complex technical issues',
            skill3: '•	Create and optimize complex PL/SQL stored procedures for Oracle Databases',
            skill4: '•	Design and Implement large Enterprise Web applications using Microservices Architecture and REST APIs',
            skill5: '•	Write Unit and Integration test and Shell Sripts (Bash and KornShell)',
            skill6: '•	Work using Agile approach - Scrums, Code review, Sprint review and planning',
            skill7: '•	Document functional and technical specifications',
            skill8: '•	Create Use Case, Architecturals, Functional and Sequential diagrams',
            skill9: '•	Learn fast new technologies adopted by compagnies',
            skill10: '•	Knowledge transfer and coachin of Junior developers',
            skill11: '•	Provide exceptional service and help to internal and external clients',
            technology1: 'Java 8-7-11-17, | GoLang, | Angular, | React, | Jquery, | JavaScript, | Nodejs, | JSP,',
            technology2: 'PHP, | XML, | HTML, | CSS, | Vue.js, | Junit, | JasperReports, | IBM Process Designer,',
            technology3: 'FlexPLM, | AWS (S3 and Lambda), | Microsoft Azure, | GWT, | Spring, | Spring Boot,',
            technology4: 'SpringJPA, | Maven, | Struts, | ORM, | Hibernate, | Swagger, | SonarQube and SonarCloud,',
            technology5: 'Jira, | Confluence, | PL/SQL, | Oracle, | MSSQL Server, | MySQL, | Sybase,',
            technology6: 'Tomcat, | Weblogic, | Websphere, | Jboss, | Windows, | Unix, | Docker,',
            technology7: 'Jenkins, | Openshift, | Nexus Repository, | Artifactory, | Git, | GitLab, | BitBucket.',
            experience1:'Full Stack Developer',
            work_period1: ' | May 2023 - Present',
            company1: 'Design4Logic',
            location1: ' | Montreal',
            note1: '(Self employed)',
            task1: 'Create Proofs of Concept, develop and maintain Web applications for different clients',
            experience2:'QA Architect',
            work_period2: ' | January 2025 - February 202',
            company2: 'NSI Canada',
            location2: ' | Montreal ',
            // note2: '',
            task2: 'Analyzed code quality and developed test strategies.',
            experience3:'Full Stack Developer',
            work_period3: ' | April 2024 - June 2024',
            company3: 'Élections Québec',
            location3: ' | Québec City',
            note3: '(Consultant for Transition Services Conseils)',
            task3: 'Modified and optimized PL/SQL stored procedures. Maintained and deployed Java applications',
            experience3a:'Senior Java Developer',
            work_period3a: ' | may 2023 - april 2024',
            company3a: 'Immigration, Refugees and Citizenship Canada',
            location3a: ' | Montreal',
            //note3a: '(Consultante pour Transition Services Conseils)',
            task3a: 'Prepared Functional and Technical Specs based on Job Requirements. Use Case, Class, Activity and Sequence diagrams. Developed and integrated applications.',
            experience4:'Senior Java Developer',
            work_period4: ' | September 2022 - March 2023',
            company4: 'Humania Assurance',
            location4: ' | Saint_Hyacinthe',
            // note4: '',
            task4: 'Developed, tested, and deployed company’s applications.',
            experience5: 'Java Developer',
            work_period5: ' | January 2022 - April 2022 ',
            company5: 'Desjardins',
            location5: ' | Montreal ',
            note5: '(Consultant for COFOMO)',
            task5: 'Developed, tested, and deployed APIs.',
            experience6:'Java Developer',
            work_period6: ' | October 2021 - December 2021',
            company6: 'COFOMO',
            location6: ' | Montreal',
            // note6: '',
            task6: 'Developed internal applications and Proofs of Concept, helped intervewing candidates for Java Developer positions.',
            experience7:'Java Developer',
            work_period7: ' | April 2019 - September 2021',
            company7: 'Hydro-Québec',
            location7: ' | Montreal ',
            note7: '(Consultant for COFOMO)',
            task7: 'Developed, tested, integrated and deployed company\'s applications.',
            experience8:'Full Stack Developer',
            work_period8: ' | September 2018 - March 2019',
            company8: 'Prospects Software',
            location8: ' | Verdun',
            // note10: '',
            task8: 'Developed et maintained Prospects CRM.',
            experience9:'Full Stack Developer ',
            work_period9: ' | September 2017 - August 2018',
            company9: 'CGI',
            location9: ' | Montréal',
            // note11: '',
            task9: 'Created des Proofs of Concept using Java, as well as Graphic Design proposals for Web and Mobile applications. Evaluated new software and helped interviewing candidates.',
            experience10:'Application Development Consultant',
            work_period10: ' | October 2016 - September 2017',
            company10: 'Laurentian Bank',
            location10: ' | Montreal',
            note10: '(Consultant for CGI)',
            task10: 'Developed, maintained et deployed applications. Updated and installed different UNIX tools.',
            experience11:'Level 3 Application Support',
            work_period11: ' | July 2013 - September 2016',
            company11: 'Deutsche Bank',
            location11: ' | New York',
            note11: '(Consultant for CGI)',
            task11: 'Found root causes and recommended solutions of complex technical problems of  Deutsche Bank’s investment platform processing millions of investment transactions every day.',
            domain1: 'TELECOMMUNICATIONS',
            domain1_company1: 'COGECO Cable',
            domain1_company2: 'Rogers Media',
            domain2: 'BANKING',
            domain2_company1: 'Deutsche Bank',
            domain2_company2: 'Laurentian Bank',
            domain2_company3: 'Desjardins',
            domain2_company4: 'National Bank of Canada',
            domain3: 'RETAIL',
            domain3_company1: 'Reitmans Lmtd',
            domain4: 'ELECTRIC ENERGY',
            domain4_company1: 'Hydro-Qu/bec',
            domain5: 'INSURANCE',
            domain5_company1: 'Humania Assurance',
            domain6: 'GOVERNEMENT',
            domain6_company1: 'Élections Québec',
            slavic: 'SLAVIC',
            latin: 'LATIN',
            french1: 'French',
            french2: '(Full professional proficiency)',
            english1: 'English',
            english2: '(Full professional proficiency)',
            ukrainian1: 'Ukrainian',
            ukrainian2: '(Native or bilingual proficiency)',
            polish1: 'Polish',
            polish2: '(Limited professional proficiency)',
            russian1:'Russian',
            russian2:'(Native or bilingual proficiency)',
            langues: 'Français, Anglais, Ukrainien, Russe.',
            diploma: 'Bachelor of Computer Science',
            option: 'Option: Computer Applications',
            gpa:'GPA: 3.46 (A)',
            distinction: '(Graduated with distinction)',
            university: 'Concordia University',
            study_period: 'Montreal | September 1998 - June 2004',
            honours: 'HONOURS AND AWARDS',
            goldenkey: 'Golden Key International Honour Society',
            gkposition: 'Webmaster and member',
            projects: 'PROJECTS',
            project1: 'Bank application back-end (Java, Kafka)',
            project2: 'Bank application front-end (React)',
            project3: 'Algorithms (Java)',
            project4: 'Microservices (Java, Eureka)',
            project5: 'Credit Card Payment (Java)',
            project6: 'AWS S3 (Java)',
            project7: 'AWS Lambda (Java)',
            project8: 'Load Balancer (Java)',
            project9: 'URL Shortener Back-end (Java)',
            project10: 'URL Shortener Front-end (React)',
            project11: 'OAuth2 Authorization Server (Java)',
            project12: 'OAuth2 Resource Server (Java)',
            project13: 'Node.js MVC pattern',
            contact_email: 'Contact by email',
            contact_phone: 'Contact by phone'
          }
        }
      },

      fr: {
        translation: {
          description: {
            part1: 'Éditez <1>src/App.js</1> et sauvez pour recharger.',
            part2: 'Apprenez React',
            about: 'À PROPOS',
            technologies: 'TECHNOLOGIES',
            techskills: 'COMPÉTENCES TECHNIQUES',
            techskill1: 'Développement Full-Stack Java',
            techskill2: 'Infonuagique',
            techskill3: 'DevOps',
            techskill4: 'Cybersecurité',
            techskill5: 'OAuth2',
            techskill6: 'Microservices',
            techskill7: 'APIs REST',
            techskill8: 'PL/SQL',
            techskill9: 'Kafka',
            techskill10: 'SonarQube',
            techskill11: 'Nodejs',
            techskill12: 'Shell Scripting',
            experience: 'EXPÉRIENCE',
            domains: 'DOMAINES',
            education: 'FORMATION',
            languages: 'LANGUES',
            phone: 'Tél.: 514-742-6851',
            email: 'Courriel: tamara9@rogers.com',
            linkedin: 'Profil LinkedIn: linkedin.com/in/tamaram',
            technologies1: 'TECHNOLOGIES UTILISÉES',
            experiences1: 'EXPÉRIENCES PROFESSIONNELLES',
            domains1: 'DOMAINES D\'EXPÉRIENCE',
            languages1: 'LANGUES',
            languages2: '(parlées, lues, écrites)',
            education1: 'FORMATION PROFESSIONELLE',
            profile: 'PROFIL',
            skills: 'CHAMPS DE COMPÉTENCES',
            profile1: '•	Professionnelle confirmée avec expérience de plus de 15 années en technologies Java',
            profile2: '•	Travaille dans tous les étapes de SDLC',
            profile3: '•	Développement, intégration et maintien des application Web pour différentes industries',
            profile4: '•	Collaboration avec des équipes internationales aux États-Unis, Royaume Uni, Inde, etc.',
            profile5: '•	Langues : Français, Anglais, Ukrainien, Russe',
            skill1: '•	Développer, maintenir, déployer et supporter des applications Web',
            skill2: '•	Résoudre des problèmes informatiques complexes',
            skill3: '•	Créer et optimiser des procédures complexes en PL/SQL pour BD Oracle',
            skill4: '•	Design des application avec l’architecture Microservices et APIs REST',
            skill5: '•	Écrire des tests unitaires et intégrés. Écrire des scripts shell (Bash et Korn Shell)',
            skill6: '•	Approche Agile – Scrums, revue de code, revue et planification des nouveaux Sprints',
            skill7: '•	Documenter des spécifications fonctionnelles et techniques',
            skill8: '•	Créer des diagrammes des cas d’usage, d’architecture, fonctionnelles et séquentielles.',
            skill9: '•	Apprendre des nouvelles technologies rapidement',
            skill10: '•	Transférer des connaissances et former des développeurs juniors',
            skill11: '•	Fournir le service exceptionnel aux clients internes et externes',
            technology1: 'Java 8-7-11-17-21-25, | GoLang, | Angular, | React, | Jquery, | JavaScript, | Nodejs, | JSP,',
            technology2: 'PHP, | XML, | HTML, | CSS, | Vue.js, | Junit, | JasperReports, | IBM Process Designer,',
            technology3: 'FlexPLM, | AWS (S3 et Lambda), | Microsoft Azure, | GWT, | Spring, | Spring Boot,',
            technology4: 'SpringJPA, | Maven, | Struts, | ORM, | Hibernate, | Swagger, | SonarQube et SonarCloud,',
            technology5: 'Jira, | Confluence, | PL/SQL, | Oracle, | MSSQL Server, | MySQL, | Sybase,',
            technology6: 'Tomcat, | Weblogic, | Websphere, | Jboss, | Windows, | Unix, | Docker,',
            technology7: 'Jenkins, | Openshift, | Nexus Repository, | Artifactory, | Git, | GitLab, | BitBucket.',
            experience1:'Développeuse Full Stack',
            work_period1: ' | mai 2023 - à ce jour',
            company1: 'Design4Logic',
            location1: ' | Montréal',
            note1: 'A mon compte',
            task1: 'Créer de Preuves de la Conception, développer et maintenir des applications.',
            experience2:'Architecte en Assurance Qualité',
            work_period2: ' |  janvier 2025 - février 2025',
            company2: 'NSI Canada',
            location2: ' | Montréal ',
            // note2: '',
            task2: 'Analysé la qualité du code et développé des stratégies de tests..',
            experience3:'Développeuse Full Stack',
            work_period3: ' | avril 2024 - juin 2024',
            company3: 'Élections Québec',
            location3: ' | Ville de Québec',
            note3: '(Consultante pour Transition Services Conseils)',
            task3: 'Modifié des procédures stockées en PL/SQL. Maintenu et déployé des applications Java.',
            // note3: '',
            experience3a:'Développeuse Java Senior',
            work_period3a: ' | mai 2023 - avril 2024',
            company3a: 'Immigration, Réfugiés et Citoyenneté Canada',
            location3a: ' | Montréal',
            //note3a: '(Consultante pour Transition Services Conseils)',
            task3a: 'Préparé les spécifications Fonctionnelles et Techniques basées sur les requêtes du travail et les diagrammes de Cas d’Utilisation, Classes, Activité et Sequence. Developpé et integré les applications.',
            experience4:'Développeuse Java Senior',
            work_period4: ' | Septembre 2022 - Mars 2023',
            company4: 'Humania Assurance',
            location4: ' | Saint-Hyacinthe',
            // note4: '',
            task4: 'Développé, testé, et déployé des applications de la compagnie.',
            experience5: 'Développeuse Java',
            work_period5: ' | janvier 2022 - avril 2022 ',
            company5: 'Desjardins',
            location5: ' | Montreal ',
            note5: '(Consultante pour COFOMO)',
            task5: 'Developpé, testé, et deployé des APIs.',
            experience6:'Développeuse Java',
            work_period6: ' | octobre 2021 - décembre 2021',
            company6: 'COFOMO',
            location6: ' | Montreal',
            // note6: '',
            task6: 'Développé des applications internes et des preuves de la conception. Aidé aux entrevues des candidats pour les postes de développeurs Java.',
            experience7:'Développeuse Java',
            work_period7: ' | April 2019 - September 2021',
            company7: 'Hydro-Québec',
            location7: ' | Montréal ',
            note7: '(Consultante pour Nexio)',
            task7: 'Développé, testé, intégré et déployé des applications de la compagnie.',
            experience8:'Développeuse Full Stack',
            work_period8: ' | septembre 2018 - mars 2019',
            company8: 'Prospects Software',
            location8: ' | Verdun',
            // note8: '',
            task8: 'Développé et maintenu l’application Prospects CRM. Développé des nouvaux modules au Prospects CRM.',
            experience9:'Développeuse Full Stack',
            work_period9: ' | septembre 2017 - août 2018',
            company9: 'CGI',
            location9: ' | Montréal',
            // note9: '',
            task9: 'Créé des preuves de la conception avec Java, incluant les propositions de design graphique pour applications Web et applications mobiles. Évalué des nouveaux logiciels et aidé aux entrevues.',
            experience10:'Conseillère en Développement Applicatif',
            work_period10: ' | octobre 2016 - septembre 2017',
            company10: 'Banque Laurentienne',
            location10: ' | Montréal',
            note10: '(Consultant pour CGI)',
            task10: 'Développé, maintenu et déployé des applications. Effectué les mises à jour des outils UNIX.',
            experience11:'Support applicatift de niveau 3',
            work_period11: ' | juillet 2013 - septembre 2016',
            company11: 'Deutsche Bank',
            location11: ' | New York',
            note11: '(Consultante pour CGI)',
            task11: 'Trouvé des causes premières et proposé des solutions de problèmes techniques complèxes de la plateforme de la Deutsche Bank qui effectue le traitement des millions des transactions d’investissement chaque jour.',
      
            domain1: 'TELECOMMUNICATIONS',
            domain1_company2: 'COGECO Cable',
            domain1_company1: 'Rogers Média',
            domain2: 'BANQUAIRE',
            domain2_company1: 'Deutsche Bank',
            domain2_company2: 'Banque Laurentienne',
            domain2_company3: 'Desjardins',
            domain2_company4: 'Banque Nationale du Canada',
            domain3: 'COMMERCE DE DÉTAILS',
            domain3_company1: 'Reitmans Ltée',
            domain4: 'ÉNERGIE ÉLECTRIQUE',
            domain4_company1: 'Hydro-Québec',
            domain5: 'ASSURANCE',
            domain5_company1: 'Humania Assurance',
            domain6: 'GOUVERNEMENT',
            domain6_company1: 'Élections Québec',
            slavic: 'SLAVES',
            latin: 'LATINS',
            french1: 'Français',
            french2: '(Maîtrise professionnelle complète)',
            english1: 'Anglais',
            english2: '(Maîtrise professionnelle complète)',
            ukrainian1: 'Ukrainien',
            ukrainian2: '(Langue maternelle)',
            polish1: 'Polonais',
            polish2: '(Maîtrise professionnelle limité)',
            russian1:'Russe',
            russian2:'(Langue maternelle)',
            langues: 'Français, Anglais, Ukrainien, Russe.' ,
            diploma: 'Baccalauréat en Sciences Informatiques',
            option: 'Option: Applications Informatiques',
            gpa:'Grade: 3.46 (A)',
            distinction: '(Gradué avec distinction)',
            university: 'Université Concordia',
            study_period: 'Montréal | septembre 1998 - juin 2004',
            honours: 'HONNEURS ET RECOMPENSES',
            goldenkey: 'Société internationale d\'honneur Golden Key',
            gkposition: 'Webmestre et membre de la société',
            projects: 'PROJETS',
            project1: 'Back-end de l\'appli Bank (Java, Kafka)',
            project2: 'Front-end de l\'appli Bank (React)',
            project3: 'Algorithmes (Java)',
            project4: 'Microservices (Java, Eureka)',
            project5: 'Paiement par Carte de Crédit (Java)',
            project6: 'AWS S3 (Java)',
            project7: 'AWS Lambda (Java)',
            project8: 'Load Balancer (Java)',
            project9: 'URL Shortener Back-end (Java)',
            project10: 'URL Shortener Front-end (React)',
            project11: 'Serveur d\'Authorization OAuth2 (Java)',
            project12: 'Serveur de Ressources OAuth2 (Java)',
            project13: 'Node.js MVC',
            contact_email: 'Contact par courriel',
            contact_phone: 'Contact par téléphone'
          }
        }
      }
    }
  });


export default i18n;